<template>
  <vx-tooltip v-if="text" :text="text" position="right" class="nav-info-icon">
    <span @click.stop.prevent>
      <feather-icon icon="InfoIcon" svgClasses="w-3 h-3" />
    </span>
  </vx-tooltip>
</template>

<script>
// Sidebar "i" icon explaining what a menu is for. Text comes from
// navInfo.<slug> in i18nData.js when translated, else the item's `info`.
export default {
  name: 'nav-info-icon',
  props: {
    item: { type: Object, required: true },
  },
  computed: {
    text() {
      const key = `navInfo.${this.item.slug}`
      return this.$te(key) ? this.$t(key) : this.item.info || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-info-icon {
  display: inline-flex;
  flex-shrink: 0;
  margin-left: auto;
  padding-left: 0.5rem;
  opacity: 0.45;
  cursor: help;

  &:hover {
    opacity: 1;
  }
}
</style>
